<section id="dynamic-category-header-2345567" class="header-layout-3 dynamic-header-background dynamic-header-theme">
    <div class="header-container">
        @if (headerData.logo.isVisibleOnDesktop && isDesktop()) {
        <a class="only-desktop" [routerLink]="['/']">
            <img [src]="headerData.logo.logoSrc" class="header-logo" />
        </a>
        }

        <div class="header-wrapper">
            <div class="header-bottom-content animated fadeIn" [hidden]="showMobileSearchPanel">
                @if (isMobile() && headerData.menuListVisibleOnMobile) {
                <img class="ham-menu-icon only-mobile" [src]="headerData.hamburgerMenuIcon" (click)="toggleHamburgerMenu()" />
                }
                @if (!isBrowser && headerData.logo.isVisibleOnMobile) {
                <a class="only-mobile" [routerLink]="['/']">
                    <img [src]="headerData.logo.logoSrc" class="header-logo" />
                </a>
                } @else {
                @if (headerData.logo.isVisibleOnMobile && isMobile()) {
                <a class="only-mobile" [routerLink]="['/']">
                    <img [src]="headerData.logo.logoSrc" class="header-logo" />
                </a>
                }
                }
                @if (headerData.searchIcon.isVisibleOnDesktop && isDesktop()) {
                <base-search-bar class="only-desktop header-3-search-bar" [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="showMobileSearchPanel" />
                }

                <ul class="layout-3 quick-link-list">
                    @if (headerData.accountIcon.isVisibleOnMobile && isMobile()) {
                    <li (click)="isHamburgerMenu = false" class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                        <a [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                            <img [src]="headerData.accountIcon.accountIconSrc" class="quick-icon-img" />
                        </a>
                    </li>
                    } @else {
                    @if (headerData.accountIcon.isVisibleOnDesktop && isDesktop()) {
                    <li class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                        <a [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                            <img [src]="headerData.accountIcon.accountIconSrc" class="quick-icon-img" />
                        </a>
                    </li>
                    }
                    }
                    @if (headerData.cartIcon.isVisibleOnDesktop && isDesktop()) {
                    <li class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                        <div class="cart-item-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                            {{ cart.cart_items.length }}
                        </div>
                        <a [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                            <img [src]="headerData.cartIcon.cartIconSrc" class="quick-icon-img" />
                        </a>
                    </li>
                    } @else {
                    @if (headerData.cartIcon.isVisibleOnMobile && isMobile()) {
                    <li (click)="isHamburgerMenu = false" class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                        <div class="cart-item-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                            {{ cart.cart_items.length }}
                        </div>
                        <a [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                            <img [src]="headerData.cartIcon.cartIconSrc" class="quick-icon-img" />
                        </a>
                    </li>
                    }
                    }
                    @if (headerData.storeLocationDesktop.isVisibleOnDesktop && isDesktop()) {
                    <div class="only-desktop">
                        <li class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                            <a [target]="headerData.storeLocationDesktop.target" [attr.data-click_action_value]="headerData.storeLocationDesktop['data-click_action_value']" [attr.data-click_action_choice]="headerData.storeLocationDesktop['data-click_action_choice']">
                                <img [src]="headerData.storeLocationDesktop.storeLocationDesktopSrc" class="quick-icon-img" />
                            </a>
                        </li>
                    </div>
                    } @else {
                    @if (headerData.storeLocationDesktop.isVisibleOnMobile && isMobile()) {
                    <div class="only-desktop">
                        <li class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                            <a [target]="headerData.storeLocationDesktop.target" [attr.data-click_action_value]="headerData.storeLocationDesktop['data-click_action_value']" [attr.data-click_action_choice]="headerData.storeLocationDesktop['data-click_action_choice']">
                                <img [src]="headerData.storeLocationDesktop.storeLocationDesktopSrc" class="quick-icon-img" />
                            </a>
                        </li>
                    </div>
                    }
                    }

                    <div class="only-mobile">
                        <li class="dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius">
                            <a (click)="toggleSearchDropDown()">
                                <img [src]="headerData.searchIcon.searchIconSrc" class="quick-icon-img" />
                            </a>
                        </li>
                    </div>
                </ul>
            </div>

            @if (showMobileSearchPanel) {
            <div class="mobile-search-panel animated fadeInDown">
                <base-search-bar class="header-3-search-bar" [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="showMobileSearchPanel" />
                <img [src]="headerData.closeIcon" class="search-mobile-close-icon" (click)="toggleSearchDropDown()" />
            </div>
            }
            @if (headerData.menuListVisibleOnDesktop) {
            <hr class="horizontal-divider" />
            <div class="desktop-category-list" #changeHeaderElement>
                <nav class="mega-menu-category">
                    <ul class="layout-3 header-menu-list dynamic-menu-alignment" [class.remove-scroll]="layoutType() === 'hoverLayout1'">
                        @for (staticMenu of headerData.menuItems; track staticMenu) {
                        @if (staticMenu.text !== 'Category Header') {
                        <li class="static-menu">
                            <a [ngClass]="{
                        'hover-color-active': showActiveColor && currentMenuId === staticMenu.id,
                        'hover-color-inactive': !showActiveColor && currentMenuId === staticMenu.id,
                      }" [id]="staticMenu.id" (click)="onLinkClick()" class="static-header dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu" [target]="staticMenu.target" [attr.data-click_action_value]="staticMenu['data-click_action_value']" [attr.data-click_action_choice]="staticMenu['data-click_action_choice']">
                                {{ staticMenu.text }}
                            </a>

                            @if (staticMenu.subMenu?.length) {
                            <div (mouseenter)="showActiveColor = true; currentMenuId = staticMenu.id" (mouseleave)="removeHoverStyle()" class="sub-menu-header hide-sub-menu-header dynamic-sub-menu-background">
                                <div class="sub-menu-header-content">
                                    @for (subMenu of staticMenu.subMenu; track subMenu) {
                                    <div class="grid-column">
                                        <a (click)="onLinkClick()" [target]="subMenu.target" [attr.data-click_action_value]="subMenu['data-click_action_value']" [attr.data-click_action_choice]="subMenu['data-click_action_choice']" class="parent-category-name dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                            {{ subMenu.text }}
                                        </a>
                                        @if (subMenu.subMenu?.length) {
                                        <ul>
                                            @for (subSubMenu of subMenu.subMenu; track subSubMenu) {
                                            <li>
                                                <a (click)="onLinkClick()" [target]="subSubMenu.target" [attr.data-click_action_value]="subSubMenu['data-click_action_value']" [attr.data-click_action_choice]="subSubMenu['data-click_action_choice']" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                                    {{ subSubMenu.text }}
                                                </a>
                                            </li>
                                            }
                                        </ul>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                        </li>
                        }
                        }

                        <div #dynamicCategoryHeader>
                            @if (dynamicHeaderInline() && layoutType() === 'inlineLayout1') {
                            @for (parentCategory of category; track parentCategory) {
                            <li>
                                <a [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu" [ngClass]="{
                          'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                          'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                        }" (click)="onLinkClick()">
                                    {{ parentCategory.name }}
                                </a>

                                @if (parentCategory.sub_categories.length) {
                                <div (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()" class="sub-menu-header hide-sub-menu-header dynamic-sub-menu-background">
                                    <div class="sub-menu-header-content">
                                        @for (childCategory of parentCategory.sub_categories; track childCategory) {
                                        <div class="grid-column">
                                            <a [routerLink]="'category/' + childCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: childCategory.url_path }" (click)="onLinkClick()" class="parent-category-name dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                                {{ childCategory.name }}
                                            </a>
                                            @if (childCategory.sub_categories.length) {
                                            <ul>
                                                @for (subCategory of childCategory.sub_categories; track subCategory) {
                                                <li>
                                                    <a [routerLink]="'category/' + subCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: subCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                                        {{ subCategory.name }}
                                                    </a>
                                                </li>
                                                }
                                            </ul>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>
                                }
                            </li>
                            }
                            }
                            @if (dynamicHeaderHover() && layoutType() === 'hoverLayout1') {
                            <li class="fly-out-menu">
                                <a (click)="onLinkClick()" class="category-menu-name dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu">
                                    {{ headerData.categoryMenuName }}
                                </a>

                                @if (category) {
                                <ul class="layout-3">
                                    @for (parentCategory of category; track parentCategory) {
                                    <li class="dynamic-sub-menu-background hide-sub-menu-header">
                                        <a [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu" [ngClass]="{
                                'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                                'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                              }">
                                            {{ parentCategory.name }}
                                        </a>

                                        @if (parentCategory.sub_categories.length) {
                                        <ul class="layout-3" (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()">
                                            @for (childCategory of parentCategory.sub_categories; track childCategory) {
                                            <li class="dynamic-sub-menu-background">
                                                <a [routerLink]="'category/' + childCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: childCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                                    {{ childCategory.name }}
                                                </a>

                                                @if (childCategory.sub_categories.length) {
                                                <ul class="layout-3">
                                                    @for (subCategory of childCategory.sub_categories; track subCategory) {
                                                    <li class="dynamic-sub-menu-background">
                                                        <a [routerLink]="'category/' + subCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: subCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                                            {{ subCategory.name }}
                                                        </a>
                                                    </li>
                                                    }
                                                </ul>
                                                }
                                            </li>
                                            }
                                        </ul>
                                        }
                                    </li>
                                    }
                                </ul>
                                }
                            </li>
                            }
                        </div>
                    </ul>
                </nav>
            </div>
            }
        </div>

        @if (isHamburgerMenu) {
        <div appClickOutside #changeHeaderMobileElement class="mobile-subcategory-list animated fadeInLeft mobile-category-panel">
            <ul *ngIf="false" class="mobile-menu-list">
                @for (staticMenu of headerData.menuItems; track staticMenu) {
                @if (staticMenu.text !== 'Category Header') {
                <li class="static-menu-mobile">
                    <a class="static-header dynamic-header-font-size dynamic-header-text-color dynamic-header-hover-text-color hoverMenu" [target]="staticMenu.target" [attr.data-click_action_value]="staticMenu['data-click_action_value']" [attr.data-click_action_choice]="staticMenu['data-click_action_choice']">
                        {{ staticMenu.text }}
                    </a>
                </li>
                }
                }

                <ul>
                    @for (parentCategory of category; track parentCategory) {
                    <li>
                        <a [routerLink]="'category/' + parentCategory.url_path" class="dynamic-header-text-color hoverSubMenu">
                            {{ parentCategory.name }}
                        </a>
                        <ul>
                            @for (childCategory of parentCategory.sub_categories; track childCategory) {
                            <li>
                                <a [routerLink]="'category/' + childCategory.url_path" class="dynamic-header-text-color hoverSubMenu">
                                    {{ childCategory.name }}
                                </a>
                                <ul>
                                    @for (subCategory of childCategory.sub_categories; track subCategory) {
                                    <li>
                                        <a [routerLink]="'category/' + subCategory.url_path" class="dynamic-header-text-color hoverSubMenu">
                                            {{ subCategory.name }}
                                        </a>
                                    </li>
                                    }
                                </ul>
                            </li>
                            }
                        </ul>
                    </li>
                    }
                </ul>
            </ul>

            <static-menu-collapse (hideMenu$)="toggleHamburgerMenu()" [headerData]="headerData" />

            @if (
            (dynamicHeaderInline() && layoutType() === 'inlineLayout1') ||
            (dynamicHeaderHover() && layoutType() === 'hoverLayout1')
            ) {
            <webstore-dynamic-menu-collapse #dynamicCategoryHeaderMobile [categories]="category || []" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleHamburgerMenu()" />
            }
        </div>
        }
    </div>
</section>